import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { verifyOTP, verifyUserID } from 'src/services/Login/ForgotPassword'
import { loadingState } from 'src/atom/LoadingState'
import Tostify, { showToast } from 'src/utils/Tostify'
import LogoHeader from 'src/components/header/LogoHeader'
import { FaKey, FaArrowLeft } from 'react-icons/fa'

const ValidatePassword = () => {
  const [formData, setFormData] = useState({ id: '', mobileOTP: '' })
  const [showResendButton, setShowResendButton] = useState(false)
  const [countdown, setCountdown] = useState(120)
  const [isChecked, setIsChecked] = useState(false)
  const [loading, setLoading] = useState(false)
  const [validationErrors, setValidationErrors] = useState({ mobileOTP: '' })
  const [userId, setUserId] = useState('')
  const [token, setToken] = useState('')
  const [loader, enableLoader] = useRecoilState(loadingState)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (location.state) {
      setUserId(location.state.userId || '')
      setToken(location.state.token || '')
    }
  }, [location.state])

  useEffect(() => {
    let timer = null
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000)
    } else {
      setShowResendButton(true)
    }
    return () => clearTimeout(timer)
  }, [countdown])

  const handleResend = async () => {
    if (!userId) {
      showToast('User ID not available', 'error')
      return
    }
    setShowResendButton(false)
    setCountdown(120)
    try {
      const response = await verifyUserID(userId)
      const bodyValues = Object.values(response.body)
      setToken(bodyValues)
      if (response.success) {
        showToast('OTP sent Successfully!', 'success')
      } else {
        showToast(response.message || 'Failed to send OTP', 'error')
      }
    } catch (error) {
      showToast(error.message || 'An error occurred', 'error')
    }
  }

  const validateForm = () => {
    let errors = {}
    let isValid = true
    if (!formData.mobileOTP) {
      errors.mobileOTP = 'Please provide OTP'
      isValid = false
    }
    setValidationErrors(errors)
    return isValid
  }

  const verifyOtp = async () => {
    if (!token) {
      showToast('Token not available', 'error')
      return
    }
    setLoading(true)
    enableLoader(true)
    try {
      const response = await verifyOTP(token, formData.mobileOTP)
      if (response.success) {
        navigate('/confirm-password', { state: { userId: token } })
      } else {
        showToast(response.message || 'OTP verification failed', 'error')
        setFormData((prev) => ({ ...prev, mobileOTP: '' }))
      }
    } catch (error) {
      showToast(error.message || 'An error occurred while verifying OTP', 'error')
    } finally {
      enableLoader(false)
      setLoading(false)
      setIsChecked(false)
    }
  }

  const handleOTPChange = (e) => {
    const { value } = e.target
    const numericValue = value.replace(/\D/g, '')
    const truncatedValue = numericValue.slice(0, 4)
    setFormData((prev) => ({ ...prev, mobileOTP: truncatedValue || null }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsChecked(true)
    if (validateForm()) {
      verifyOtp()
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          overflow: 'hidden',
        }}
      >
        <div className="card" style={{ border: 'none', borderRadius: 0 }}>
          <LogoHeader />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f4f4f4',
            padding: '2rem 1rem',
            overflow: 'auto',
          }}
        >
          <div
            style={{
              width: '100%',
              maxWidth: '460px',
              backgroundColor: '#ffffff',
              borderRadius: '18px',
              boxShadow: '0 12px 32px rgba(0, 0, 0, 0.1)',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                backgroundColor: '#3a0d5f',
                padding: '24px 28px',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
              }}
            >
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  minWidth: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#4d5f7c',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <FaKey size={20} color="#ffffff" />
              </div>
              <div>
                <p style={{ color: '#ffffff', fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>
                  Validate Password
                </p>
                <p style={{ color: '#C9D1DB', fontSize: '0.8rem', margin: 0 }}>
                  Enter the OTP to continue
                </p>
              </div>
            </div>

            <div style={{ padding: '28px' }}>
              <label style={{ color: '#DC2626', fontSize: '0.85rem', marginBottom: '16px', display: 'block' }}>
                <span>
                  OTP has been generated and sent to your registered email ID and mobile number
                </span>
              </label>

              <div style={{ display: 'flex', gap: '10px' }}>
                <input
                  type="text"
                  className={`form-control ${validationErrors.mobileOTP ? 'is-invalid' : ''}`}
                  id="OTP"
                  maxLength="4"
                  placeholder="One time password"
                  value={formData.mobileOTP || ''}
                  onChange={handleOTPChange}
                  disabled={loading}
                  style={{
                    padding: '10px 14px',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    backgroundColor: loading ? '#F3F4F6' : '#ffffff',
                  }}
                />
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={loading || !formData.mobileOTP || isChecked}
                  style={{
                    backgroundColor: '#3a0d5f',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '10px 20px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    opacity: loading || !formData.mobileOTP || isChecked ? 0.6 : 1,
                  }}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    'Validate'
                  )}
                </button>

                {showResendButton && (
                  <button
                    type="button"
                    onClick={handleResend}
                    disabled={loading}
                    style={{
                      backgroundColor: '#DC2626',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '10px 20px',
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                      opacity: loading ? 0.6 : 1,
                    }}
                  >
                    Resend
                  </button>
                )}
              </div>
              {validationErrors.mobileOTP && (
                <div style={{ color: '#DC2626', fontSize: '0.8rem', marginTop: '6px' }}>
                  {validationErrors.mobileOTP}
                </div>
              )}

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <Link
                  to="/login"
                  style={{
                    color: '#3a0d5f',
                    fontSize: '0.9rem',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                  }}
                >
                  <FaArrowLeft size={12} /> Back to Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Tostify />
    </>
  )
}

export default ValidatePassword